import React, { Fragment, ReactNode } from 'react';
import { ModalsKeys } from 'global';
import { useSelector } from 'react-redux';
import { LoadModal } from './Load/LoadModal';
import { modalsSelectors } from 'redux/modalsReducer';
import { SwitchAccountDialog } from 'modules/user/additionalAccounts';
import { ConfirmationModal } from './Confirmation/ConfirmationModal';
import { FileUploadModal } from './FileUpload/FileUploadModal';

export const CommonModals = () => {
  const openedModals = useSelector(modalsSelectors.openedModals) as ModalsKeys[];

  const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
    [ModalsKeys.Load]: <LoadModal />,
    [ModalsKeys.Confirmation]: <ConfirmationModal />,
    [ModalsKeys.SwitchAccountDialog]: <SwitchAccountDialog />,
    [ModalsKeys.FileUploadDialog]: <FileUploadModal />,
  };

  return (
    <>
      {openedModals.map(modalKey => (
        <Fragment key={modalKey}>{modalsWithKeys[modalKey]}</Fragment>
      ))}
    </>
  );
};
